import { WalletOutlined } from '@ant-design/icons';
import { useNavigate } from '@tanstack/react-location';
import { Menu, Tag } from 'antd';
import React from 'react';

import {
  useGetMyPaywallStatusQuery,
  useGetMySubscriptionRequestQuery,
} from '@/generated/graphql';
import { toSubscription } from '@/views/Subscription/routes';

interface Props {
  key: string | number;
  subscriptionType: string;
}

function SubscriptionMenuItem({
  key,
  subscriptionType,
}: Props): React.ReactElement {
  const { data, loading } = useGetMySubscriptionRequestQuery();
  const { data: paywallData } = useGetMyPaywallStatusQuery();
  const navigate = useNavigate();

  const hasFixedPlan = paywallData?.myPaywallStatus?.selectedPlan === 'fixed';

  if (hasFixedPlan) {
    return null;
  }

  if (
    loading ||
    !data ||
    !data.mySubscriptionRequest ||
    subscriptionType === 'subscription' ||
    !subscriptionType
  ) {
    return null;
  }

  return (
    <Menu.Item
      key={key}
      onClick={() =>
        navigate({
          to: toSubscription(),
        })
      }
      icon={<WalletOutlined />}
    >
      Mina villkor
    </Menu.Item>
  );
}

export default SubscriptionMenuItem;
